import { FileActionButton } from "../file-action/file-action-controls";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useEffect, useState, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import posService from "../../services/pos/pos.service";
import { InputText } from "primereact/inputtext";
import { TabView, TabPanel } from "primereact/tabview";
import { Badge } from "primereact/badge";
import { Toast } from "primereact/toast";
import { OutwardRequestExport } from "./OutwardRequestExport";
import { InwardRequestExport } from "./InwardRequestExport";

interface Props {
  visible: boolean;
  onHide: () => void;
  posId: number[];
  onSendRequest: (request: any) => void;
  onRejectRequest: (request: any) => void;
  onSendinwardRequest: (request: any) => void;
  onRejectinwardRequest: (request: any) => void;
  setLoading: (loading: boolean) => void;
}

const IncomingRequestsDialog: React.FC<Props> = ({
  visible,
  onHide,
  posId,
  onSendRequest,
  onRejectRequest,
  onSendinwardRequest,
  onRejectinwardRequest,
  setLoading
}) => {
  const toast = useRef<Toast>(null);
  const [requests, setRequests] = useState<any[]>([]);
  const [Inwardrequest, setInwardrequest] = useState<any[]>([]);
  const [selectedRequest, setSelectedRequest] = useState<any | null>(null);
  const [selectedInwardRequest, setSelectedInwardRequest] = useState<any | null>(null);
  const [documentDetails, setDocumentDetails] = useState<string>("");
  const [note, setNote] = useState<string>("");
  const [showAcceptDialog, setShowAcceptDialog] = useState(false);
  const [showRejectDialog, setShowRejectDialog] = useState(false);
  const [showInwardAcceptDialog, setShowInwardAcceptDialog] = useState(false); // for inward request
  const [showInwardRejectDialog, setShowInwardRejectDialog] = useState(false); // for inward request
  const [keywordSearchOutward, setKeywordSearchOutward] = useState('');
  const [filteredOutwardRequests, setFilteredOutwardRequests] = useState<any[]>([]);
  const [keywordSearchInward, setKeywordSearchInward] = useState('');
  const [filteredInwardRequests, setFilteredInwardRequests] = useState<any[]>([]);

  useEffect(() => {
    const fetchRequests = async () => {
      try {
        const response = await posService.Getposrequest(posId);
        if (response) {
          setRequests(response);
          setFilteredOutwardRequests(response); // Initialize filtered requests
          console.log("requstsdata:", response)
        } else {
          setRequests([]);
        }
      } catch (error) {
        console.error("Error fetching POS requests", error);
        setRequests([]);
      }
    };
    const fetchInwardRequests = async () => {
      try {
        const response = await posService.GetposInwardrequest(posId);
        if (response) {
          setInwardrequest(response);
          setFilteredInwardRequests(response); // Initialize filtered inward requests
          console.log("inwardrequestdata:", response)
        } else {
          setInwardrequest([]);
        }
      } catch (error) {
        console.error("Error fetching POS inward requests", error);
        setInwardrequest([]);
      }
    };

    if (visible && posId) {
      fetchRequests();
      fetchInwardRequests();
    }
  }, [visible, posId]);

  const handleSubmitAccept = async () => {
    if (!documentDetails.trim()) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation Error",
        detail: "Document Details are required.",
      });
      return;
    }

    try {
      const Stock = await posService.GetposporductDetails(selectedRequest.requestToPOS, selectedRequest.productId);

      if (selectedRequest.quantity > Stock[0].currentStock) {
        toast.current?.show({
          severity: "error",
          summary: "Insufficient Stock",
          detail: "Requested quantity exceeds current stock in the POS.",
        });
        return;
      }

      const updatedRequest = {
        ...selectedRequest,
        documentDetails,
        note,
      };

      onSendRequest(updatedRequest);

      const removeId = selectedRequest.id;
setRequests(prev => prev.filter(r => r.id !== removeId));
setFilteredOutwardRequests(prev => prev.filter(r => r.id !== removeId));
      setShowAcceptDialog(false);
      setDocumentDetails("");
      setNote("");
      setSelectedRequest(null);
    } catch (error) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to validate stock. Please try again.",
      });
      console.error("Stock validation error:", error);
    }
  };

  const handleRejectRequest = () => {
    if (!note.trim()) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation Error",
        detail: "Note is required for rejection",
      });
      return;
    }

    const rejectRequest = {
      ...selectedRequest,
      note,
    };

    onRejectRequest(rejectRequest);
    const removeId = selectedRequest.id;
setRequests(prev => prev.filter(r => r.id !== removeId));
setFilteredOutwardRequests(prev => prev.filter(r => r.id !== removeId));
    setShowRejectDialog(false);
    setNote("");
    setSelectedRequest(null);
  };

  const actionTemplate = (rowData: any) => {
    return (
      <div className="flex gap-2">
        <Button
          icon="pi pi-send"
          label="Accept"
          className="px-1 py-2 text-sm"
          onClick={() => {
            setSelectedRequest(rowData);
            setDocumentDetails("");
            setNote("");
            setShowAcceptDialog(true);
          }}
        />
        <Button
          icon="pi pi-times"
          label="Reject"
          severity="danger"
          className="px-1 py-2 text-sm"
          onClick={() => {
            setSelectedRequest(rowData);
            setNote(""); // clear previous note
            setShowRejectDialog(true);
          }}
        />
      </div>
    );
  };

  const handleSubmitinwardAccept = () => {
    if (!documentDetails.trim()) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation Error",
        detail: "Document Details are required.",
      });
      return;
    }

    const updatedRequest = {
      ...selectedInwardRequest,
      documentDetails,
      note,
    };

    onSendinwardRequest(updatedRequest);
    const removeId = selectedInwardRequest.id;
setInwardrequest(prev => prev.filter(r => r.id !== removeId));
setFilteredInwardRequests(prev => prev.filter(r => r.id !== removeId));
    setShowInwardAcceptDialog(false);
    setDocumentDetails("");
    setNote("");
    setSelectedInwardRequest(null);
  };

  const handleRejectinwardRequest = () => {
    if (!note.trim()) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation Error",
        detail: "Note is required for rejection",
      });
      return;
    }

    const rejectRequest = {
      ...selectedInwardRequest,
      note,
    };

    onRejectinwardRequest(rejectRequest);
    const removeId = selectedInwardRequest.id;
setInwardrequest(prev => prev.filter(r => r.id !== removeId));
setFilteredInwardRequests(prev => prev.filter(r => r.id !== removeId));
    setShowInwardRejectDialog(false);
    setNote("");
    setSelectedInwardRequest(null);
  };


  const actionTemplate1 = (rowData: any) => {
    return (
      <div className="flex gap-2">
        <Button
          icon="pi pi-send"
          label="Accept"
          className="px-1 py-2 text-sm"
          onClick={() => {
            setSelectedInwardRequest(rowData);
            setDocumentDetails("");
            setNote("");
            setShowInwardAcceptDialog(true);
          }}
        />
        <Button
          icon="pi pi-times"
          label="Reject"
          severity="danger"
          className="px-1 py-2 text-sm"
          disabled
          onClick={() => {
            setSelectedInwardRequest(rowData);
            setNote("");
            setShowInwardRejectDialog(true);
          }}
        />
      </div>
    );
  };

  const formatDateFromString = (dateStr: string) => {
    const dt = new Date(dateStr);
    const day = dt.getDate().toString().padStart(2, '0');
    const month = (dt.getMonth() + 1).toString().padStart(2, '0');
    const year = dt.getFullYear();
    return `${day}-${month}-${year}`; // e.g. 18-08-2025
  };

  const handleOutwardSearch = (query: string) => {
    setKeywordSearchOutward(query);

    if (query.trim() === '') {
      setFilteredOutwardRequests(requests);
    } else {
      const lowerQuery = query.toLowerCase();
      const filtered = requests.filter(req =>
        req.productName?.toLowerCase().includes(lowerQuery) ||
        req.requestFromPosCode?.toLowerCase().includes(lowerQuery)
      );
      setFilteredOutwardRequests(filtered);
    }
  };

  const handleInwardSearch = (query: string) => {
    setKeywordSearchInward(query);

    if (query.trim() === '') {
      setFilteredInwardRequests(Inwardrequest);
    } else {
      const lowerQuery = query.toLowerCase();

      const filtered = Inwardrequest.filter(req =>
        req.productName?.toLowerCase().includes(lowerQuery) ||
        req.requestToPosCode?.toLowerCase().includes(lowerQuery)
      );
      setFilteredInwardRequests(filtered);
    }
  };


  return (
    <>
      <Toast ref={toast} />
      <Dialog
        header="Requests"
        visible={visible}
        onHide={onHide}
        style={{ width: "70vw" }}
        modal
      >
        <TabView>
          <TabPanel header={
            <span style={{ display: 'flex', alignItems: 'center', minHeight: '24px' }}>
              Outward Requests{" "}
              {requests.length > 0 && (
                <Badge value={requests.length} severity="danger" className="ml-2" />
              )}
            </span>
          }>
            <div className="flex justify-content-between align-items-center mb-3">
              <div className="p-input-icon-left w-full md:w-4">
                <i className="pi pi-search" />
                <InputText
                  type="search"
                  value={keywordSearchOutward}
                  onChange={(e) => handleOutwardSearch(e.target.value)}
                  placeholder="Search Requests"
                  className="w-full"
                              style={{
    border: "1px solid #75bb8aff",
    boxShadow: "0 0 0 1px #75bb8aff",
  }}
                />
              </div>
              {
                requests.length > 0 &&
                <FileActionButton action="export"
                  className="text-black border-round ml-3"
                  onClick={() => OutwardRequestExport(filteredOutwardRequests)}
                  icon="pi pi-file-excel"
                  text
                  raised
                >
                  Export Outward Requests
                </FileActionButton>
              }
            </div>
            {requests.length === 0 ? (
              <p>No Outward Requests.</p>
            ) : (
              <DataTable
                value={filteredOutwardRequests}
                paginator
                rows={10}
                rowsPerPageOptions={[10, 25, 50, 100]}
                className="p-datatable-sm"
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
              >
                <Column field="requestedDate" header="Requested Date"
                  body={(rowData) => formatDateFromString(rowData.requestedDate)} sortable style={{ width: "150px" }} />
                <Column field="productName" header="Product Name" sortable />
                <Column field="quantity" header="Quantity" style={{ width: "100px" }} sortable />
                <Column field="requestFromPosCode" header="Requested By" sortable />
                <Column field="requestToPosCode" header="Requested To" sortable />
                <Column header="Actions" body={actionTemplate} style={{ width: "180px" }} />
              </DataTable>
            )}
          </TabPanel>
          <TabPanel header={
            <span style={{ display: 'flex', alignItems: 'center', minHeight: '24px' }}>
              Inward Requests{" "}
              {Inwardrequest.length > 0 && (
                <Badge value={Inwardrequest.length} severity="warning" className="ml-2" />
              )}
            </span>
          }>
            <div className="flex justify-content-between align-items-center mb-3">
              <div className="p-input-icon-left w-full md:w-4">
                <i className="pi pi-search" />
                <InputText
                  type="search"
                  value={keywordSearchInward}
                  onChange={(e) => handleInwardSearch(e.target.value)}
                  placeholder="Search Requests"
                  className="w-full"
                              style={{
    border: "1px solid #75bb8aff",
    boxShadow: "0 0 0 1px #75bb8aff",
  }}
                />
              </div>
              {
                Inwardrequest.length > 0 &&
                <FileActionButton action="export"
                  className="text-black border-round ml-3"
                  onClick={() => InwardRequestExport(filteredInwardRequests)}
                  icon="pi pi-file-excel"
                  text
                  raised
                >
                  Export Inward Requests
                </FileActionButton>
              }
            </div>
            {Inwardrequest.length === 0 ? (
              <p>No Inward Requests.</p>
            ) : (
              <DataTable
                value={filteredInwardRequests}
                paginator
                rows={10}
                rowsPerPageOptions={[10, 25, 50, 100]}
                className="p-datatable-sm"
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
              >
                <Column field="respondedDate" header="sent Date" sortable
                  body={(rowData) => formatDateFromString(rowData.respondedDate)} style={{ width: "150px" }} />
                <Column field="productName" header="Product Name" sortable />
                <Column field="quantity" header="Quantity" style={{ width: "100px" }} sortable
                  body={(rowData: any) => {
                    if (rowData.batches && rowData.batches.length > 0) {
                      return rowData.batches.reduce((sum: number, b: any) => sum + (Number(b.quantity) || 0), 0);
                    }
                    return rowData.quantity ?? rowData.totalQuantity ?? 0;
                  }}
                />
                <Column field="requestToPosCode" header="sent By" sortable />
                <Column field="requestFromPosCode" header="sent To" sortable />
                <Column header="Actions" body={actionTemplate1} style={{ width: "180px" }} />
              </DataTable>
            )}
          </TabPanel>
        </TabView>
      </Dialog>



      <Dialog
        header="Accept Request - Add Details"
        visible={showAcceptDialog}
        onHide={() => setShowAcceptDialog(false)}
        style={{ width: "30vw" }}
        modal
      >
        <div className="p-fluid">
          <div className="field">
            <label htmlFor="doc">Document Details *</label>
            <InputText
              id="doc"
              value={documentDetails}
              onChange={(e) => setDocumentDetails(e.target.value)}
              placeholder="Enter document details"
              required
              style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
            />
          </div>

          <div className="field mt-3">
            <label htmlFor="note">Note (optional)</label>
            <InputText
              id="note"
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="Enter note if any"
              style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
              maxLength={255}
            />
          </div>

          <div className="flex justify-content-end gap-2 mt-4">
            <Button
              label="Cancel"
              icon="pi pi-times"
              className="p-button-secondary"
              onClick={() => setShowAcceptDialog(false)}
            />
            <Button
              label="Submit"
              icon="pi pi-check"
              onClick={handleSubmitAccept}
            />
          </div>
        </div>
      </Dialog>
      {/* reject Dialog  for requst */}
      <Dialog
        header="Reject Request - Add Note"
        visible={showRejectDialog}
        onHide={() => setShowRejectDialog(false)}
        style={{ width: "30vw" }}
        modal
      >
        <div className="p-fluid">
          <div className="field">
            <label htmlFor="rejectNote">Note *</label>
            <InputText
              id="rejectNote"
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="Enter reason for rejection"
              required
              style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
              maxLength={255}
            />
          </div>

          <div className="flex justify-content-end gap-2 mt-4">
            <Button
              label="Cancel"
              icon="pi pi-times"
              className="p-button-secondary"
              onClick={() => setShowRejectDialog(false)}
            />
            <Button
              label="Reject"
              icon="pi pi-check"
              severity="danger"
              onClick={handleRejectRequest}
            />
          </div>
        </div>
      </Dialog>


      {/* inward accept */}
      <Dialog
        header="Accept Inward Request - Add Details"
        visible={showInwardAcceptDialog}
        onHide={() => setShowInwardAcceptDialog(false)}
        style={{ width: "30vw" }}
        modal
      >
        <div className="p-fluid">
          <div className="field">
            <label htmlFor="doc">Document Details *</label>
            <InputText
              id="doc"
              value={documentDetails}
              onChange={(e) => setDocumentDetails(e.target.value)}
              placeholder="Enter document details"
              required
              style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
            />
          </div>

          <div className="field mt-3">
            <label htmlFor="note">Note (optional)</label>
            <InputText
              id="note"
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="Enter note if any"
              style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
              maxLength={255}
            />
          </div>

          <div className="flex justify-content-end gap-2 mt-4">
            <Button
              label="Cancel"
              icon="pi pi-times"
              className="p-button-secondary"
              onClick={() => setShowInwardAcceptDialog(false)}
            />
            <Button
              label="Submit"
              icon="pi pi-check"
              onClick={handleSubmitinwardAccept}
            />
          </div>
        </div>
      </Dialog>

      <Dialog
        header="Reject Inward Request - Add Note"
        visible={showInwardRejectDialog}
        onHide={() => setShowInwardRejectDialog(false)}
        style={{ width: "30vw" }}
        modal
      >
        <div className="p-fluid">
          <div className="field">
            <label htmlFor="rejectNote">Note *</label>
            <InputText
              id="rejectNote"
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="Enter reason for rejection"
              required
              style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
              maxLength={255}
            />
          </div>

          <div className="flex justify-content-end gap-2 mt-4">
            <Button
              label="Cancel"
              icon="pi pi-times"
              className="p-button-secondary"
              onClick={() => setShowInwardRejectDialog(false)}
            />
            <Button
              label="Reject"
              icon="pi pi-check"
              severity="danger"
              onClick={handleRejectinwardRequest}
            />
          </div>
        </div>
      </Dialog>



    </>

  );
};

export default IncomingRequestsDialog;
